export function chunk(arr, chunkSize) {
  const finalArray = arr && Array.isArray(arr) ? arr : [];
  // eslint-disable-next-line prefer-spread
  return [].concat.apply(
    [],
    finalArray.map((elem, i) => (i % chunkSize ? [] : [finalArray.slice(i, i + chunkSize)])),
  );
}
